import React from "react";
import { useSelector } from "react-redux";
import { uniq } from "lodash";
import VirtualCongressBackground from "./virtual_congress_background";
import ImageMapBackgroundVideo from "./image_map_background_video";
import useMobile from "../effects/use_mobile";
import { HtmlContentImageMap } from "./image_map/html_content_image_map";
import { IframeImageMap } from "./image_map/iframe_image_map";
import { DefaultImageMap } from "./image_map/default_image_map";

require("velocity-animate");
require("velocity-animate/velocity.ui");

// const forEachSeries = async (iterable, action) => {
//   for (const x of iterable) {
//     await action(x)
//   }
// }

const ImageMapContent = (props) => {
  const { imageMap } = props;

  switch (imageMap.render_mode) {
    case "html_content":
      return <HtmlContentImageMap imageMap={imageMap} />;
    case "iframe":
      return <IframeImageMap imageMap={imageMap} />;
    default:
      return <DefaultImageMap {...props} />;
  }
};

export default function GenericImageMap(props) {
  const { imageMap } = props;
  const { isMobileByMediaQuery, isMobileByUserAgent } = useMobile();
  const imageMaps = useSelector((state) => state.imageMaps);

  if (!imageMap) {
    return <div className="alert alert-danger">No map available</div>;
  }

  // Image preloading
  //useEffect(() => {
  //
  //
  //  if (!window.imageMapImagesCached) {
  //    window.imageMapImagesCached = true
  //
  //    const imageUrlList = imageMaps.map(imageMap => imageMap.background_image_url)
  //
  //
  //    console.debug("Preloading ...")
  //    const preloadImage = (url) => {
  //      return new Promise((resolve, reject) => {
  //        // reject("Some error")
  //        console.debug(`Preload ${url}`)
  //        const img = new Image();
  //        img.onload = () => {
  //          resolve()
  //        }
  //        img.onerror = () => {
  //          resolve()
  //        }
  //        img.src = url
  //      });
  //    }
  //
  //    forEachSeries(imageUrlList, preloadImage)
  //
  //  }
  //}, [])

  return (
    <VirtualCongressBackground key={"imageMapgen" + imageMap.id}>
      {!isMobileByUserAgent && !isMobileByMediaQuery && (
        <ImageMapBackgroundVideo imageMap={imageMap} />
      )}

      <ImageMapContent {...props} />

      {uniq(
        imageMaps
          .filter(
            (imageMap) =>
              imageMap.background_image_url &&
              imageMap.background_image_url != ""
          )
          .map((imageMap) => imageMap.background_image_url)
      ).map((background_image_url) => (
        <img
          key={"preloadImg" + background_image_url}
          src={background_image_url}
          style={{ display: "none" }}
        />
      ))}
    </VirtualCongressBackground>
  );
}
